export default __webpack_public_path__ + "static/media/bag3.77ae2dd4.jpg";